export default __webpack_public_path__ + "static/media/stamp.2f9e7d4b.jpg";